import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sidebar from './sidebar';
import Overlay from '../components/overlay';
import Header from './header';
import PosLeftNav from './pos_left_nav';
import PosSearchNav from './pos_search_nav';
import OpenOrdersItems from './open_orders_items';
import ModalOrderPayment from './modal_order_payment';
import ModalOrderClose from './modal_order_close';
import _ from 'lodash';

class OpenOrders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemsPerLoad: 20,
      itemsShown: 0,
      openOrders: '',
    }
  }

  componentWillMount() {
    // When about to load, grab any open orders
    this.gatherOpenOrders(this.props.orders);
  }

  componentWillReceiveProps(nextProps) {
    // Update openOrders when the order reducers changes
    this.gatherOpenOrders(nextProps.orders);
  }

  // Take the orders reducer and grab any open orders and keep it in
  // local component state
  gatherOpenOrders = orders => {
    orders = Object.values(orders);

    // Grab orders from the orders reducer which are 'NEW' and save
    // it to the component state
    let openOrders = orders.filter(function(order) {
      return order.order_status === 'NEW';
    });

    // Show newest orders first
    openOrders = _.orderBy(openOrders, ['order_time_start'], ['desc']);

    // Is this our initial load? (or less orders than itemsPerLoad)
    if (this.state.itemsShown < this.state.itemsPerLoad) {
      // If we have more to load, start with only itemsPerLoad
      if (openOrders.length > this.state.itemsPerLoad) {
        this.setState({ itemsShown: this.state.itemsPerLoad });
      // We have less orders than itemsPerLoad
      } else {
        this.setState({ itemsShown: openOrders.length });
      }
    }

    this.setState({ openOrders: openOrders });
  }

  // When the user clicks on the load more button
  handleLoadMore() {
    this.setState({ itemsShown: (this.state.itemsShown + this.state.itemsPerLoad)});
  }

  // When to show the load more button
  renderLoadMore() {
    if (this.state.openOrders.length > this.state.itemsShown) {
      return (
          <button type="button" onClick={event => this.handleLoadMore()} className="btn btn-black waves-effect waves-light">Load More Items</button>
        );
    }
  }

  render() {
    return(
      <div>
        <Overlay />
        <Sidebar />
        <Header />
        <div className="site-content">
          <nav className="navbar navbar-light bg-white navbar-bottom-line b-a mb-1 p-1">
            <div className="container pl-0 pr-0">
              <div className="row">
                <PosLeftNav />
                <PosSearchNav orderType="open" />
              </div>
            </div>            
          </nav>
          <div className="box box-block">
            <div className="table-responsive">
              <OpenOrdersItems openOrders={this.state.openOrders.slice(0, this.state.itemsShown)} />
            </div>
            <div className="float-xs-left">
              {this.renderLoadMore()}
            </div>
            <br />
          </div>
        </div>
        <ModalOrderPayment />
        <ModalOrderClose />
    </div>
    );
  }
}

function mapStateToProps({ orders }) {
  return { orders };
}

export default connect(mapStateToProps, null)(OpenOrders);



// WEBPACK FOOTER //
// ./src/containers/open_orders.js